import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

/**
 * Injectable del componente
 */
@Injectable({
  providedIn: 'root',
})

/**
 * Servicio responsable de notificar mensajes al cliente
 */
export class NotificationService {
  /**
   * Configuración base para el modal
   */
  private readonly baseConfig: MatSnackBarConfig = {
    duration: 10000,
    horizontalPosition: 'center',
    verticalPosition: 'bottom',
    panelClass: ['notification-snackbar', 'snackbar-centered', 'white-close-button'],
  };

  /**
   * Barra de notificación
   */
  private readonly snackBar: MatSnackBar;

  /**
   * Zona de notificación
   */
  private readonly zone: NgZone;

  /**
   * Constructor de NotificationService
   * @param snackBar Barra de notificación
   * @param zone Zona de ejecución
   */
  public constructor(snackBar: MatSnackBar, zone: NgZone) {
    this.snackBar = snackBar;
    this.zone = zone;
  }

  /**
   * Muestra un mensaje de éxito
   * @param message Mensaje a mostrar
   */
  public showSuccess(message: string): void {
    this.zone.run(() => {
      this.snackBar.open(message, 'X', {
        ...this.baseConfig,
        panelClass: ['notification-snackbar', 'snackbar-centered', 'success-snackbar', 'white-close-button'],
      });
    });
  }

  /**
   * Muestra un mensaje de error
   * @param message Mensaje a mostrar
   */
  public showError(message: string): void {
    this.zone.run(() => {
      this.snackBar.open(message, 'X', {
        ...this.baseConfig,
        panelClass: ['notification-snackbar', 'snackbar-centered', 'error-snackbar', 'white-close-button'],
      });
    });
  }

  /**
   * Muestra un mensaje de advertencia
   * @param message Mensaje a mostrar
   */
  public showWarning(message: string): void {
    this.zone.run(() => {
      this.snackBar.open(message, 'X', {
        ...this.baseConfig,
        duration: 3000,
        panelClass: ['notification-snackbar', 'snackbar-centered', 'warning-snackbar', 'white-close-button'],
      });
    });
  }
}
